<template>

<div id="videowrapper">
    <div class="fullscreendesktop">
       <video id="video" role="presentation" preload="auto" playsinline crossorigin="anonymous" loop muted autoplay>
            <source src="hero/16x9_V4.mp4" type="video/mp4">
        </video>
        <div id="videotext"> 
<h1 class="hero-title fade-1">The best beer in the&nbsp;world?</h1>
<h1 class="hero-title fade-2">Probably.</h1>
        </div>   
    </div>
    <div class="fullscreenmobile">
       <video id="video" role="presentation" preload="auto" playsinline crossorigin="anonymous" loop muted autoplay>
            <source src="hero/4x5_V4.mp4" type="video/mp4">
        </video>
        <div id="videotext-mob">
          <h1 class="hero-title-mob fade-1">The best beer in the<br>world? <span class="fade-2">Probably.</span> </h1>
  
        </div>   
    </div>
    <a href="https://www.drinkaware.ie" target="_blank">
			<img src="hero/ie-drinkaware-white.png" class="drinkaware">
		</a>    
</div>


</template>

<script setup>

import dataModel from '../js/model.js';
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1"
  },
});
$(document).ready(function() {
  $('.navbar').css({
    backgroundColor: dataModel[props.brandExperience].ui.primaryColor
  });
  
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.darker::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: '';
    background-color: rgba(0,0,0,0.15);
}

.video {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  width: 100%;
}

.height--100p {
    height: 100%;
}

#videowrapper{  
    position: relative;
    overflow: hidden;
} 

.fullscreendesktop {
    min-height: 100%; 
    height: auto;
    width: 100vw;
    padding:0;
    margin: 0;
    position: relative;
    z-index: -1;

    @media screen and (max-width: 600px) {
    display: none;
    }
}

.fullscreenmobile {
    display: none;

    @media screen and (max-width: 600px) {
    display: block;
    }
}

#video{    
    width: 100vw; 
    height: auto;
    margin: auto;
    display: block;
}

#videotext{
    width: 100%; 
    height: 100%;
    position: absolute; 
    top: 80px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    align-self: auto;

    @media screen and (max-width: 1000px) {
    top: 40px;
  }
}

#videotext-mob{
    width: 100%; 
    height: 100%;
    position: absolute; 
    top: 20px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    align-self: auto;
}

.hero-title {
  font-size: 3.6vw;
  font-weight: bold;
  margin-bottom: 0px;
  color: $color--green;
  text-align: left;
  padding: 0 0 0 50px;

  @media screen and (max-width: 1000px) {
    font-size: 4.2vw;
  }
  @media screen and (max-width: 700px) {
    padding: 0 0 0 20px;
  }
}

.hero-title-mob {
  font-size: 6.5vw;
  font-weight: bold;
  margin-bottom: 0px;
  color: $color--green;
  text-align: left;
  padding: 0 0 0 20px;
}

.fade-1 {
  animation: 3s ease 0s normal forwards 1 fadeIn;
  -webkit-animation: 3s ease 0s normal forwards 1 fadeIn;
  -moz-animation: 3s ease 0s normal forwards 1 fadeIn;
  -o-animation: 3s ease 0s normal forwards 1 fadeIn;
  -ms-animation: 3s ease 0s normal forwards 1 fadeIn;
}

.fade-2 {
  animation: 7s ease 0s normal forwards 1 fadeIn;
  -webkit-animation: 7s ease 0s normal forwards 1 fadeIn;
  -moz-animation: 7s ease 0s normal forwards 1 fadeIn;
  -o-animation: 7s ease 0s normal forwards 1 fadeIn;
  -ms-animation: 7s ease 0s normal forwards 1 fadeIn;
}

@keyframes fadeIn {
  0% {opacity:0;}
  60% {opacity: 0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  60% {opacity: 0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-o-keyframes fadeIn {
  0% {opacity:0;}
  60% {opacity: 0;}
  100% {opacity:1;}
}

@-ms-keyframes fadeIn {
  0% {opacity:0;}
  60% {opacity: 0;}
  100% {opacity:1;}
}

.drinkaware{
  position: absolute;
  bottom: 50px;
  left: 50px;
  width: 200px;
  z-index: 12;

  @media screen and (max-width: 700px) {
    bottom: 20px;
    left: 20px;
    width: 180px;
  }

  @media screen and (max-width: 550px) {
    bottom: 10px;
    left: 10px;
    }

}
.mobile {
  display: none;
}

@media screen and (max-width: 550px) {
    .fullscreendesktop {
      display: none;
    }
    .fullscreenmobile {
      display: block;
    }

  }

</style>